import { useCampaignInvoiceStatus } from '@jobilla/nexus-sdk'

export function useCampaignInvoiceData(organisationId: string, campaignId: string) {
	const invoice = useCampaignInvoiceStatus(organisationId, campaignId)

	return {
		invoice: invoice.data,
		isLoading: invoice.isLoading,
	}
}
